import {MatPaginatorIntl} from '@angular/material/paginator';
const getRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0) {
    return `Seite 1 von 1`;
  }
  const amountPages = Math.ceil(length / pageSize);
  return `Seite ${page + 1} von ${amountPages}`;
};

export function getGermanPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.firstPageLabel = `Erste Seite`;
  paginatorIntl.itemsPerPageLabel = `Elemente pro Seite:`;
  paginatorIntl.lastPageLabel = `Letzte Seite`;

  paginatorIntl.nextPageLabel = 'Nächste Seite';
  paginatorIntl.previousPageLabel = 'Vorherige Seite';
  paginatorIntl.getRangeLabel = getRangeLabel;

  return paginatorIntl;
}
